module.exports = __webpack_public_path__ + "img/no_image_strain.f98b32ce.png";